import * as React from 'react';
import { Button } from '@cian/ui-kit';
import { useSelector } from 'react-redux';

import { useCallbackButton } from './useCallbackButton';
import { selectCallbackButtonTextExperimentActive } from '../../selectors/experiments';
import { TRequestCallbackOpener } from '../../types/microfrontends/newbuildingCallbackWidget';

interface ISecondaryCallbackButtonProps {
  placeType: TRequestCallbackOpener;
}

export function SecondaryCallbackButton({ placeType }: ISecondaryCallbackButtonProps) {
  const [isAvailable, handleClick, isLoading] = useCallbackButton(placeType);
  const isCallbackButtonTextExperimentActive = useSelector(selectCallbackButtonTextExperimentActive);
  // TODO: Занести выигравший text внутрь SecondaryCallbackButton в CD-190865.
  const buttonText = isCallbackButtonTextExperimentActive ? 'Заказ звонка' : 'Перезвоните мне';

  if (!isAvailable) {
    return null;
  }

  return (
    <Button theme="fill_secondary" size={'M'} onClick={handleClick} fullWidth loading={isLoading}>
      {buttonText}
    </Button>
  );
}
